<template>
    <v-main class="px-0 mx-1">
        <v-container fluid class="pa-0">
             <v-row justify="center" align="center" class="py-3" :class="this.$vuetify.theme.dark == true?'grey darken-4':'grey lighten-4'" >
                <v-col md="12" lg="10" sm="11" xs="12" class="pt-3 bottom-space"  >
                  <UserHeader/>
                </v-col>
             </v-row>
        </v-container>

        <v-container fluid class="pa-0">
             <v-row justify="center" align="center" class="py-3" :class="this.$vuetify.theme.dark == true?'black':''">
                <v-col md="12" lg="10" sm="11" xs="12" class="pt-3 card-top-margin">
                  <v-container fluid class="py-0 my-0">
    <v-row align="center" justify="center" class="py-0 my-0">
      <v-col cols="6" md="6" lg="6" sm="6" class="py-0 my-0">
        <v-row class="py-0 my-0">
          <v-col md="12" lg="12" sm="12" cols="12" class="pa-1 mb-6">
            <PasswortCard />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
                </v-col>
             </v-row>
        </v-container>


    </v-main>

</template>

<script>
import service from '@/services/appservices'
export default {
    name:'ForgotPW',
    inject: ['theme'],
    components:{
        UserHeader:()=>import('@/components/user/UserHeader'),
        PasswortCard: () => import("@/components/user/PasswortCard")
    },
    data:() =>({
      loader:true,
      ErrorMsg:''
    }),

}
</script>

<style scoped>
  @media screen and (min-width: 600px) {
    .card-top-margin {
      margin-top:-110px
    }
    .bottom-space{
      margin-bottom: 80px;
      margin-top: 20px
    }
  }
  @media screen and (max-width: 600px) {
    .card-top-margin {
      margin-top:-100px
    }
    .bottom-space{
      margin-bottom: 50px
    }
  }
</style>